module.exports = __webpack_public_path__ + "img/coverpage_group_s.4d3e2cfa.png";